import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  ManifestationDataProps,
  StatusType,
  tagStatusMaps
} from '../../store/ducks/manifestations/types';
import { sendTagging } from '../../store/ducks/tagging/actions';

import { ManifestationTracking } from './ManifestationTracking';
import { ManifestationDetail } from './ManifestationDetail';
import { Container } from './styles';

import { ApplicationState } from '../../store';
import { loadManifestations } from '../../store/ducks/manifestations/actions';

export type Filters = Partial<ManifestationDataProps>;

export interface HandleDetailProps {
  manifestationId?: string;
  type?: 'back';
}

export interface FiltersProps {
  contactName?: string;
  occurrence?: string;
  orderCreatedDate?: string;
  orderNumber?: string;
  status?: string;
}

const INITIAL_FILTERS: FiltersProps = {
  contactName: '',
  occurrence: '',
  orderCreatedDate: '',
  orderNumber: '',
  status: ''
};

export const Manifestation = () => {
  const dispatch = useDispatch();

  const { manifestations, selectedCustomerId } = useSelector(
    (state: ApplicationState) => state.manifestations
  );

  const [filters, setFilters] = useState<Filters>(INITIAL_FILTERS);
  const [filteredData, setFilteredData] = useState<ManifestationDataProps[]>(
    manifestations as ManifestationDataProps[]
  );
  const [detailManifestation, setDetailManifestation] = useState<
    ManifestationDataProps | undefined
  >();

  const data =
    filteredData &&
    filteredData.length === 0 &&
    Object.values(filters).filter((value) => value).length === 0
      ? manifestations
      : filteredData;

  const filterData = (filters: Filters) => {
    const result =
      manifestations?.filter((item) => {
        return Object.entries(filters).every(([key, value]) => {
          if (key.toLowerCase() === 'status' && value === 'Todos') {
            return true;
          }

          if (!value) return true;

          const itemValue = item[key as keyof ManifestationDataProps];

          if (typeof itemValue === 'string') {
            return itemValue.toLowerCase().includes(value.toLowerCase());
          }

          return itemValue === value;
        });
      }) ?? [];

    setFilteredData(result);
  };

  const handleInputChange = (field: keyof Filters, value: string) => {
    const updatedFilters = {
      ...filters,
      [field]: value
    };

    setFilters(updatedFilters);
    filterData(updatedFilters);
  };

  const handleDetailManifestation = ({
    manifestationId,
    type
  }: HandleDetailProps) => {
    if (!manifestationId) {
      return setDetailManifestation(undefined);
    }

    const detail = manifestations?.find(
      (mft) => mft.orderNumber === manifestationId
    );

    if (detail && type === 'back') {
      dispatch(
        sendTagging({
          screenName: 'LG:Reclamações',
          reclamacao_id: manifestationId,
          status_reclamacao: detail.status,
          ocorrencia: detail.occurrence,
          data_criacao: detail.orderCreatedDate,
          detalhes_ocorrido: detail.manifestationDetails,
          veiculo_no_local: detail.vehicleOnSite,
          event: 'listar_reclamacoes'
        })
      );
      return setDetailManifestation(undefined);
    }

    if (detail) {
      dispatch(
        sendTagging({
          screenName: 'LG:Reclamações',
          reclamacao_id: manifestationId,
          status_reclamacao: detail.status,
          ocorrencia: detail.occurrence,
          data_criacao: detail.orderCreatedDate,
          event: 'clique_reclamacao'
        })
      );

      dispatch(
        sendTagging({
          screenName: 'LG:Reclamações',
          reclamacao_id: manifestationId,
          status_reclamacao: detail.status,
          ocorrencia: detail.occurrence,
          data_criacao: detail.orderCreatedDate,
          detalhes_ocorrido: detail.manifestationDetails,
          veiculo_no_local: detail.vehicleOnSite,
          event: tagStatusMaps[detail.status as StatusType]
        })
      );
      return setDetailManifestation(detail);
    }

    return setDetailManifestation(undefined);
  };

  const handleSearch = () => {
    if (selectedCustomerId) {
      setFilters(INITIAL_FILTERS);
      setFilteredData([]);
      dispatch(loadManifestations(selectedCustomerId));
    }
  };

  return (
    <Container>
      <ManifestationTracking
        {...{
          data,
          filters,
          showManifestationTable: !!detailManifestation,
          onSearch: handleSearch,
          onDetail: handleDetailManifestation,
          onFilter: handleInputChange
        }}
      />
      <ManifestationDetail
        {...{
          data: detailManifestation,
          onBack: () =>
            handleDetailManifestation({
              manifestationId: detailManifestation?.orderNumber,
              type: 'back'
            })
        }}
      />
    </Container>
  );
};
